import { useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle, FileText } from 'lucide-react';

export default function AtasSection() {
  const navigate = useNavigate();
  const features = [
    'Atas de registros de preços',
    'Contratos e fornecimentos',
    'Processos licitatórios',
    'Suporte especializado',
  ];

  return (
    <section id="atas" className="bg-gray-50 px-4 md:px-8 lg:px-12 xl:px-16 py-4">
      <div className="relative overflow-hidden rounded-lg bg-[#06172f] px-6 py-8 md:px-10 md:py-9 text-white shadow-[0_14px_34px_rgba(5,16,35,0.22)]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_72%_30%,rgba(0,200,83,0.16),transparent_34%)]" />
        <div className="absolute right-8 top-8 hidden h-40 w-28 bg-[radial-gradient(circle,rgba(0,200,83,0.20)_1px,transparent_1px)] [background-size:14px_14px] lg:block" />

        <div className="relative grid grid-cols-1 lg:grid-cols-[1fr_0.72fr_0.95fr] gap-7 lg:gap-10 items-center">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <p className="text-xs font-extrabold text-donnos-green uppercase tracking-wide">
                LICITAÇÕES E ATAS
              </p>
              <span className="h-0.5 w-8 rounded-full bg-donnos-green" />
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold leading-tight mb-4">
              Atendimento especializado para compras públicas e corporativas
            </h2>
            <p className="text-sm text-slate-300 leading-relaxed max-w-2xl">
              Facilitamos o processo de consulta, cotação e fornecimento por meio de atas, contratos e oportunidades comerciais, oferecendo suporte ágil para empresas e instituições públicas.
            </p>
          </div>

          <div className="space-y-3">
            {features.map((feature) => (
              <div key={feature} className="flex items-center gap-3 text-sm text-slate-200">
                <CheckCircle className="h-5 w-5 text-donnos-green shrink-0" aria-hidden="true" />
                <span>{feature}</span>
              </div>
            ))}
            <button
              onClick={() => navigate('/atas')}
              className="mt-2 inline-flex items-center gap-3 rounded-md bg-donnos-green px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-donnos-green-dark"
            >
              <FileText className="h-4 w-4" aria-hidden="true" />
              Consulta de Atas
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>

          <div className="hidden lg:block">
            <img
              src="/assets/atas-digital.png"
              alt="Consulta de atas digital"
              className="h-[190px] w-full rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
